// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/ticketservice/tickets.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canCreateTicketForCase } from "./check";

export function useCanCreateTicketForCase(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canCreateTicketForCase(withinScope);
  return canDoAction;
}
